import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'rankingStyleClasses',
})
export class RankingStyleClassesPipe implements PipeTransform {
	transform(currentIndex: number, startIndex: number, index: number) {
		const target = startIndex + 1;

		return {
			'py-2': true,
			'duration-600': true,
			'delay-600': index === 1,
			'delay-1200': index === 2,
			'transition-none': currentIndex !== target,
			'transition-all': currentIndex === target,
			'translate-y-full': currentIndex < target,
			'opacity-0': currentIndex < target,
			'opacity-100': currentIndex >= target,
		};
	}
}
